import React, { useEffect } from 'react';

function ToastIcon({ type }) {
  if (type === 'error') {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M12 7.5v5.5M12 16.2v.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <path d="M8 12.5l2.8 2.8L16.2 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ToastItem({ id, message, type = 'success', onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(id), 3500);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div className={`ca-toast ca-toast--${type}`} role="status">
      <span className="ca-toast__icon"><ToastIcon type={type} /></span>
      <div className="ca-toast__content">
        <div className="ca-toast__title">{type === 'error' ? 'Error' : 'Success'}</div>
        <div className="ca-toast__message">{message}</div>
      </div>
      <button
        type="button"
        className="ca-toast__close"
        aria-label="Dismiss notification"
        onClick={() => onDismiss(id)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}

export default function ToastContainer({ toasts = [], onDismiss }) {
  if (!toasts.length) return null;
  return (
    <div className="ca-toast-container">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} {...toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}